import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";

export const LIFECYCLE_LABEL = { draft: "Draft", active: "Active", closed: "Closed", cancelled: "Cancelled" };

export function useFeature(name) {
  const [on, setOn] = useState(null);
  useEffect(() => { client.get("/features").then((r) => setOn(!!r.data[name])).catch(() => setOn(false)); }, [name]);
  return on;
}

export function FlagSwitch({ v2, legacy }) {
  const on = useFeature("conviction_v2");
  if (on === null) return <div className="min-h-[60vh]" />;
  return on ? v2 : legacy;
}

export function AnalystChip({ analyst, size = 7, asLink = true }) {
  if (!analyst) return <span className="text-xs text-zinc-500" data-testid="analyst-chip-unassigned">Analyst not yet verified</span>;
  const Tag = asLink ? Link : "span";
  return (
    <Tag {...(asLink ? { to: `/analyst/${analyst.slug}` } : {})} data-testid="analyst-chip" className="inline-flex items-center gap-2 text-sm hover:text-[#ccff00]">
      {analyst.profile_image ? <img src={analyst.profile_image} alt="" style={{ width: size * 4, height: size * 4 }} className="rounded-full object-cover" /> : <span style={{ width: size * 4, height: size * 4 }} className="rounded-full bg-white/10 grid place-items-center text-xs">{analyst.name[0]}</span>}
      {analyst.name}
    </Tag>
  );
}

export function LifecyclePill({ value }) {
  const cls = value === "active" ? "border-[#ccff00]/50 text-[#ccff00]" : value === "closed" ? "border-white/30 text-zinc-200" : "border-white/10 text-zinc-500";
  return <span data-testid="lifecycle-pill" className={`px-2.5 py-1 rounded-full border text-[10px] font-mono-cl uppercase tracking-[0.14em] ${cls}`}>{LIFECYCLE_LABEL[value] || value}</span>;
}

export const signed = (v) => (v === null || v === undefined ? "-" : `${Number(v) >= 0 ? "+" : ""}${v}%`);
